import type { PublicTenant } from '@/entities/publicReport';

export interface TenantMarkProps {
    tenant: PublicTenant;
}

/**
 * Logo en naam van het keuringsbedrijf boven het codeveld en boven een pagina
 * die zegt dat de link niet werkt: ook dan ziet de koper van wie de link komt.
 * Zonder logo staat alleen de naam er.
 */
export function TenantMark({ tenant }: TenantMarkProps) {
    return (
        <div className="flex min-w-0 flex-wrap items-center gap-3">
            {tenant.logoUrl ? (
                <img
                    src={tenant.logoUrl}
                    alt=""
                    className="h-10 w-auto max-w-[160px] shrink-0 rounded-[5px] object-contain"
                />
            ) : null}
            <div className="min-w-0 text-[14px] leading-[1.3] font-medium text-[var(--text-primary)]">
                {tenant.name}
            </div>
        </div>
    );
}
